import { API_URL } from "../utils/urls"; // PT-REACT-URLS v1
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

// Public page opened by the QR code on an ID card: /verify-card/:token
const API_BASE = API_URL + "idcard";
const NAVY = "#1b2a4a";

const RESULT = {
    approved: { title: "Valid ID card", color: "#15803d", text: "This ID card is genuine and currently active." },
    expired: { title: "Expired", color: "#b45309", text: "This ID card was genuine but its validity has ended." },
    pending: { title: "Under review", color: "#b45309", text: "This card's details are being re-checked by the admin. It is not valid until approved again." },
    rejected: { title: "Not valid", color: "#b91c1c", text: "This ID card is not valid." },
    revoked: { title: "Not valid", color: "#b91c1c", text: "This ID card has been cancelled by the admin." },
    not_found: { title: "Not valid", color: "#b91c1c", text: "No ID card matches this QR code." },
};

const formatDate = (value) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ""));
    return m ? `${m[3]}-${m[2]}-${m[1]}` : "";
};

const VerifyCard = () => {
    const { token } = useParams();
    const [state, setState] = useState({ loading: true });

    useEffect(() => {
        let cancelled = false;
        const safeToken = /^[a-fA-F0-9]{32}$/.test(token || "") ? token : "invalid";
        axios
            .get(`${API_BASE}/verify/${safeToken}`, { validateStatus: () => true })
            .then((response) => {
                if (cancelled) return;
                const data = response.data && typeof response.data === "object" ? response.data : {};
                setState(data.success ? { loading: false, data } : { loading: false, error: data.message || "Could not check the card. Please try again." });
            })
            .catch(() => !cancelled && setState({ loading: false, error: "Could not check the card. Please check your internet and try again." }));
        return () => {
            cancelled = true;
        };
    }, [token]);

    const data = state.data;
    const result = data ? RESULT[data.status] || RESULT.not_found : null;

    return (
        <section className="py-5 bg-white">
            <div className="container" style={{ maxWidth: 520 }}>
                <div style={{ border: "1px solid #eee", borderRadius: 16, overflow: "hidden", boxShadow: "0 4px 18px rgba(0,0,0,.08)" }}>
                    <div style={{ background: "linear-gradient(90deg,#ff9800,#e65100)", color: "#fff", padding: "16px 20px" }}>
                        <div style={{ fontSize: 13, opacity: 0.9 }}>ID card verification</div>
                        <div style={{ fontSize: 20, fontWeight: 700 }}>{data?.title || "Dr Pravin Togadia Speaks"}</div>
                    </div>
                    <div style={{ padding: 20 }}>
                        {state.loading && <p className="mb-0">Checking...</p>}
                        {state.error && <p className="mb-0" style={{ color: "#b91c1c" }}>{state.error}</p>}
                        {result && (
                            <>
                                <div style={{ background: `${result.color}14`, borderLeft: `5px solid ${result.color}`, borderRadius: 8, padding: "12px 14px" }}>
                                    <div style={{ color: result.color, fontWeight: 700, fontSize: 20 }}>{result.title}</div>
                                    <div style={{ fontSize: 14 }}>{result.text}</div>
                                </div>
                                {data.status !== "not_found" && (
                                    <div className="d-flex mt-3" style={{ gap: 16, alignItems: "flex-start" }}>
                                        {data.photo && (
                                            <img src={data.photo} alt="" style={{ width: 100, height: 122, objectFit: "cover", borderRadius: 8, border: "3px solid #f57c00" }} />
                                        )}
                                        <div style={{ fontSize: 15 }}>
                                            <div style={{ color: NAVY, fontWeight: 700, fontSize: 19 }}>{data.name}</div>
                                            {data.holder_type && (
                                                <span style={{ display: "inline-block", background: data.holder_type === "staff" ? NAVY : "#f57c00", color: "#fff", borderRadius: 999, padding: "1px 10px", fontSize: 12, fontWeight: 700, margin: "2px 0 4px" }}>
                                                    {data.holder_type === "staff" ? "STAFF" : "MEMBER"}
                                                </span>
                                            )}
                                            {data.designation && <div style={{ color: "#f57c00", fontWeight: 600 }}>{data.designation}</div>}
                                            {data.card_no && <div>ID No.: <strong>{data.card_no}</strong></div>}
                                            {data.issued_at && <div>Issued: {formatDate(data.issued_at)}</div>}
                                            {data.valid_till && <div>Valid till: {formatDate(data.valid_till)}</div>}
                                        </div>
                                    </div>
                                )}
                                <div className="mt-3" style={{ fontSize: 12, color: "#6b7280" }}>
                                    Match the photo and name with the person carrying the card.
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VerifyCard;
